import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/gallery/page.tsx");
